<script setup lang="ts">
import { ALAvatar } from '@af-lib/vue-ui';
import { useALAvatar } from '@/features/avatar/useALAvatar';
import useMeQuery from '@/api/queries/me/useMeQuery';
import { useGlobalStore } from '@/stores/global';

const { toggleDrawer } = useGlobalStore();
const { auth } = useMeQuery();

const { avatarUrl, firstName, lastName, gradients } = useALAvatar(auth, {
  imgSize: 'thumb',
});
</script>

<template>
  <v-btn class="text-none" icon @click="toggleDrawer">
    <ALAvatar
      :avatar-url="avatarUrl"
      :firstName="firstName"
      :lastName="lastName"
      :gradients="gradients"
      size="s"
      variant="square"
    />
  </v-btn>
</template>
